import { render } from "./Teleport.vue?vue&type=template&id=c0abec94"
import script from "./Teleport.vue?vue&type=script&lang=js"
export * from "./Teleport.vue?vue&type=script&lang=js"

import "./Teleport.vue?vue&type=style&index=0&id=c0abec94&lang=css"

import exportComponent from "C:\\files\\vue3_lesson_demo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__